<div *ngIf="isLoading">
  <div style="
      position: fixed;
      z-index: 900;
      width: 100vw;
      height: 100vh;
      opacity: 80;
      top: 0;
      left: 0;
      background: #e8e8e880;
    "></div>
  <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>
<div *ngIf="data_report">
  <!-- [ngStyle]="isLoading ? { visibility: 'hidden' } : { visibility: 'visible' }" -->
  <div>
    <div *ngFor="let item of data_report">
      <div class="container">
        <div class="row justify-content-center" style="padding: 5% 0">
          <h1 class="lifedi-color" style="font-weight: bold">
            {{ item.reportname }}
          </h1>
        </div>
        <h2 style="text-decoration: underline; font-weight: bold">
          {{ item.measure_name }}
        </h2>
        <h3 [innerText]="item.report_description"></h3>
        <div *ngFor="let data of item.data;let i = index" class="justify-content-center" style="padding: 5% 0">
          <div class="row justify-content-center" style="padding: 5% 0">
            <h2 style="font-weight: bold;color: #28A745;">
              อันดับที่ {{i+1}}
            </h2>
          </div>
          <h2 class="topic" [ngStyle]="{ color: data.COLOR_CODE }" style="font-weight: bold">
            {{ data.psy_name }}
          </h2>
          <h4 [innerText]="data.psy_description"></h4>
          <div style="position: absolute; left: -5000px; width: 350px">
            <div id="sliderpdf{{ data.id }}" style="padding-top: 55%; padding-left: 10%; padding-right: 10%">
              <mat-slider thumbLabel value="{{ data.slider_value | number: '1.2-2' }}" min="{{ data.min }}"
                max="{{ data.max }}" style="pointer-events: none; width: 300px; height: 100px"></mat-slider>
            </div>
          </div>
          <div class="row" style="padding-top: 5vh">
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div id="slider1">
                <mat-slider thumbLabel value="{{ data.slider_value | number: '1.2-2' }}" min="{{ data.min }}"
                  max="{{ data.max }}" style="pointer-events: none; width: 80%"></mat-slider>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <h2 style="font-weight: bold; padding-top: 20px">
                คะแนนต่ำสุด : {{ data.min }} คะแนนสูงสุด : {{ data.max }}
              </h2>
              <h2 style="font-weight: bold" [ngStyle]="{ color: data.COLOR_CODE }">
                ท่านได้ {{ data.slider_value | number: '1.2-2' }} คะแนน
                <!-- อยู่ในช่วงคะแนน {{ data.range }} คะแนน &nbsp; -->
              </h2>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <h4 [innerText]="data.range_description"></h4>
            </div>
          </div>
        </div>
        <div style="text-align: center; padding: 5% 0" *ngIf="data_report">
          <lifedi-btn lable="ดาวน์โหลด" (click)="downloadpdf()" customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px;
            padding: 0 25px;">
          </lifedi-btn>
        </div>
      </div>
    </div>
  </div>
</div>